import { useMatches, useLocation } from "react-router-dom";
import type { ComponentType } from "react";
import { getContentFallbackForPathname } from "~/components/Layout/Fallbacks/routeContentFallbackRegistry";
import type { AppRouteHandle } from "~/types/routeHandle";

/** Nearest route `handle.contentFallback`, else pathname registry, else generic. */
export function usePageContentFallback(): ComponentType {
  const matches = useMatches();
  const location = useLocation();

  for (let i = matches.length - 1; i >= 0; i--) {
    const handle = matches[i].handle as AppRouteHandle | undefined;
    if (handle?.contentFallback) {
      return handle.contentFallback;
    }
  }

  return getContentFallbackForPathname(location.pathname);
}
